import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_placard_tasks_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { order_id?: number }): 
  Promise<{ result: { Id?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, Tasks?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, CompletedDateTime?: string, OperationCodeId?: number, Lot?: { Id?: number, LookupCode?: string }, ActualPackagedPack?: { Id?: number, Name?: string, ShortName?: string } }[] } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { order_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, Tasks?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, CompletedDateTime?: string, OperationCodeId?: number, Lot?: { Id?: number, LookupCode?: string }, ActualPackagedPack?: { Id?: number, Name?: string, ShortName?: string } }[] } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, Tasks?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, CompletedDateTime?: string, OperationCodeId?: number, Lot?: { Id?: number, LookupCode?: string }, ActualPackagedPack?: { Id?: number, Name?: string, ShortName?: string } }[] } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      order_id?: number    }) {
      return false;
    }
}
